import { Loader } from "@mantine/core";

import styles from "./FetchLoader.module.scss";

export const FetchLoader = () => {
  return (
    <div className={styles.loaderView}>
      <Loader className={styles.loader} />
    </div>
  );
};
